import { useState, useEffect } from 'react';
import { getStudentAbsenceDetails } from '../../../../services/absenceService';
import { StudentAbsenceDetails } from '../../../../types/absenceTypes';

export const useStudentAbsenceDetails = (studentId: string) => {
  const [details, setDetails] = useState<StudentAbsenceDetails | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDetails = async () => {
      if (!studentId) return;
      
      try {
        setLoading(true);
        const response = await getStudentAbsenceDetails(studentId);
        setDetails(response.data);
        setError(null);
      } catch (err) {
        setError('Failed to fetch student absence details');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [studentId]);

  return { details, loading, error };
};

export default useStudentAbsenceDetails;
